// Utility function to get flag URL from country code
export const getFlagUrl = (code: string) =>
  `https://flagcdn.com/${code.toLowerCase()}.svg`;

export const countries = [
  { value: 'Canada', code: 'ca', languages: ['English', 'French'] },
  {
    value: 'Afghanistan',
    code: 'af',
    isSupported: true,
    languages: ['Pashto', 'Dari'],
  },
  { value: 'Albania', code: 'al', languages: ['Albanian'] },
  { value: 'Algeria', code: 'dz', languages: ['Arabic'] },
  {
    value: 'Andorra',
    code: 'ad',
    languages: ['Catalan; Valencian'],
  },
  { value: 'Angola', code: 'ao', languages: ['Portuguese'] },
  { value: 'Antigua and Barbuda', code: 'ag', languages: ['English'] },
  { value: 'Argentina', code: 'ar', languages: ['Spanish; Castilian'] },
  { value: 'Armenia', code: 'am', languages: ['Armenian'] },
  { value: 'Australia', code: 'au', languages: ['English'] },
  { value: 'Austria', code: 'at', languages: ['German'] },
  { value: 'Azerbaijan', code: 'az', languages: ['Azerbaijani'] },
  { value: 'Bahamas', code: 'bs', languages: ['English'] },
  { value: 'Bahrain', code: 'bh', languages: ['Arabic'] },
  { value: 'Bangladesh', code: 'bd', languages: ['Bengali'] },
  { value: 'Barbados', code: 'bb', languages: ['English'] },
  {
    value: 'Belarus',
    code: 'by',
    isSupported: true,
    languages: ['Belarusian', 'Russian'],
  },
  { value: 'Belgium', code: 'be', languages: ['Dutch', 'French', 'German'] },
  { value: 'Belize', code: 'bz', languages: ['English'] },
  { value: 'Benin', code: 'bj', languages: ['French'] },
  { value: 'Bhutan', code: 'bt', languages: ['Dzongkha'] },
  {
    value: 'Bolivia',
    code: 'bo',
    languages: ['Spanish; Castilian', 'Quechua', 'Aymara'],
  },
  {
    value: 'Bosnia and Herzegovina',
    code: 'ba',
    languages: ['Bosnian', 'Croatian', 'Serbian'],
  },
  { value: 'Botswana', code: 'bw', languages: ['English', 'Tswana'] },
  { value: 'Brazil', code: 'br', languages: ['Portuguese'] },
  { value: 'Brunei', code: 'bn', languages: ['Malay'] },
  { value: 'Bulgaria', code: 'bg', languages: ['Bulgarian'] },
  {
    value: 'Burkina Faso',
    code: 'bf',
    isSupported: true,
    languages: ['French'],
  },
  { value: 'Burundi', code: 'bi', languages: ['Kirundi', 'French'] },
  { value: 'Cabo Verde', code: 'cv', languages: ['Portuguese'] },
  { value: 'Cambodia', code: 'kh', languages: ['Khmer'] },
  { value: 'Cameroon', code: 'cm', languages: ['French', 'English'] },
  {
    value: 'Central African Republic',
    code: 'cf',
    isSupported: true,
    languages: ['French', 'Sango'],
  },
  { value: 'Chad', code: 'td', languages: ['French', 'Arabic'] },
  { value: 'Chile', code: 'cl', languages: ['Spanish; Castilian'] },
  { value: 'China', code: 'cn', languages: ['Mandarin'] },
  { value: 'Colombia', code: 'co', languages: ['Spanish; Castilian'] },
  { value: 'Comoros', code: 'km', languages: ['Arabic', 'French'] },
  { value: 'Congo', code: 'cg', languages: ['French'] },
  { value: 'Costa Rica', code: 'cr', languages: ['Spanish; Castilian'] },
  { value: "Côte d'Ivoire", code: 'ci', languages: ['French'] },
  { value: 'Croatia', code: 'hr', languages: ['Croatian'] },
  { value: 'Cuba', code: 'cu', languages: ['Spanish; Castilian'] },
  { value: 'Cyprus', code: 'cy', languages: ['Greek', 'Turkish'] },
  { value: 'Czechia', code: 'cz', languages: ['Czech'] },
  {
    value: 'Democratic Republic of the Congo',
    code: 'cd',
    isSupported: true,
    languages: ['French'],
  },
  { value: 'Denmark', code: 'dk', languages: ['Danish'] },
  { value: 'Djibouti', code: 'dj', languages: ['Arabic', 'French'] },
  { value: 'Dominica', code: 'dm', languages: ['English'] },
  {
    value: 'Dominican Republic',
    code: 'do',
    languages: ['Spanish; Castilian'],
  },
  { value: 'Ecuador', code: 'ec', languages: ['Spanish; Castilian'] },
  { value: 'Egypt', code: 'eg', languages: ['Arabic'] },
  { value: 'El Salvador', code: 'sv', languages: ['Spanish; Castilian'] },
  {
    value: 'Equatorial Guinea',
    code: 'gq',
    languages: ['Spanish; Castilian', 'French'],
  },
  {
    value: 'Eritrea',
    code: 'er',
    languages: ['Tigrinya', 'Arabic'],
  },
  { value: 'Estonia', code: 'ee', languages: ['Estonian'] },
  { value: 'Eswatini', code: 'sz', languages: ['English', 'Swati'] },
  { value: 'Ethiopia', code: 'et', languages: ['Amharic'] },
  { value: 'Fiji', code: 'fj', languages: ['English', 'Fijian'] },
  { value: 'Finland', code: 'fi', languages: ['Finnish', 'Swedish'] },
  { value: 'France', code: 'fr', languages: ['French'] },
  { value: 'Gabon', code: 'ga', languages: ['French'] },
  { value: 'Gambia', code: 'gm', languages: ['English'] },
  { value: 'Georgia', code: 'ge', languages: ['Georgian'] },
  { value: 'Germany', code: 'de', languages: ['German'] },
  { value: 'Ghana', code: 'gh', languages: ['English'] },
  { value: 'Greece', code: 'gr', languages: ['Greek'] },
  { value: 'Grenada', code: 'gd', languages: ['English'] },
  { value: 'Guatemala', code: 'gt', languages: ['Spanish; Castilian'] },
  { value: 'Guinea', code: 'gn', languages: ['French'] },
  { value: 'Guinea-Bissau', code: 'gw', languages: ['Portuguese'] },
  { value: 'Guyana', code: 'gy', languages: ['English'] },
  {
    value: 'Haiti',
    code: 'ht',
    isSupported: true,
    languages: ['French', 'Haitian; Haitian Creole'],
  },
  { value: 'Honduras', code: 'hn', languages: ['Spanish; Castilian'] },
  {
    value: 'Hong Kong SAR (China)',
    code: 'hk',
    languages: ['Cantonese', 'English'],
  },
  { value: 'Hungary', code: 'hu', languages: ['Hungarian'] },
  { value: 'Iceland', code: 'is', languages: ['Icelandic'] },
  {
    value: 'India',
    code: 'in',
    languages: ['Hindi', 'English'],
  },
  { value: 'Indonesia', code: 'id', languages: ['Indonesian'] },
  {
    value: 'Iran',
    code: 'ir',
    isSupported: true,
    languages: ['Persian (Farsi)'],
  },
  {
    value: 'Iraq',
    code: 'iq',
    isSupported: true,
    languages: ['Arabic', 'Kurdish'],
  },
  { value: 'Ireland', code: 'ie', languages: ['Irish', 'English'] },
  { value: 'Israel', code: 'il', languages: ['Hebrew', 'Arabic'] },
  { value: 'Italy', code: 'it', languages: ['Italian'] },
  { value: 'Jamaica', code: 'jm', languages: ['English'] },
  { value: 'Japan', code: 'jp', languages: ['Japanese'] },
  { value: 'Jordan', code: 'jo', languages: ['Arabic'] },
  { value: 'Kazakhstan', code: 'kz', languages: ['Kazakh', 'Russian'] },
  { value: 'Kenya', code: 'ke', languages: ['Swahili', 'English'] },
  { value: 'Kiribati', code: 'ki', languages: ['English'] },
  { value: 'Kosovo', code: 'xk', languages: ['Albanian', 'Serbian'] },
  { value: 'Kuwait', code: 'kw', languages: ['Arabic'] },
  { value: 'Kyrgyzstan', code: 'kg', languages: ['Kyrgyz', 'Russian'] },
  { value: 'Laos', code: 'la', languages: ['Lao'] },
  { value: 'Latvia', code: 'lv', languages: ['Latvian'] },
  {
    value: 'Lebanon',
    code: 'lb',
    isSupported: true,
    languages: ['Arabic'],
  },
  { value: 'Lesotho', code: 'ls', languages: ['English', 'Southern Sotho'] },
  { value: 'Liberia', code: 'lr', languages: ['English'] },
  { value: 'Libya', code: 'ly', isSupported: true, languages: ['Arabic'] },
  { value: 'Liechtenstein', code: 'li', languages: ['German'] },
  { value: 'Lithuania', code: 'lt', languages: ['Lithuanian'] },
  {
    value: 'Luxembourg',
    code: 'lu',
    languages: ['Luxembourgish, Letzeburgesch', 'French', 'German'],
  },
  {
    value: 'Macau SAR (China)',
    code: 'mo',
    languages: ['Cantonese', 'Portuguese'],
  },
  { value: 'Madagascar', code: 'mg', languages: ['French', 'Malagasy'] },
  {
    value: 'Malawi',
    code: 'mw',
    languages: ['English'],
  },
  { value: 'Malaysia', code: 'my', languages: ['Malay'] },
  { value: 'Maldives', code: 'mv', languages: ['Divehi; Dhivehi; Maldivian;'] },
  {
    value: 'Mali',
    code: 'ml',
    isSupported: true,
    languages: ['Bambara, Fula; Fulah; Pulaar; Pular, French'],
  },
  { value: 'Malta', code: 'mt', languages: ['Maltese', 'English'] },
  {
    value: 'Marshall Islands',
    code: 'mh',
    languages: ['English', 'Marshallese'],
  },
  { value: 'Mauritania', code: 'mr', languages: ['Arabic'] },
  { value: 'Mauritius', code: 'mu', languages: ['English'] },
  { value: 'Mexico', code: 'mx', languages: ['Spanish; Castilian'] },
  { value: 'Micronesia', code: 'fm', languages: ['English'] },
  { value: 'Moldova', code: 'md', languages: ['Romanian'] },
  { value: 'Monaco', code: 'mc', languages: ['French'] },
  { value: 'Mongolia', code: 'mn', languages: ['Mongolian'] },
  { value: 'Montenegro', code: 'me', languages: ['Montenegrin'] },
  { value: 'Morocco', code: 'ma', languages: ['Arabic'] },
  { value: 'Mozambique', code: 'mz', languages: ['Portuguese'] },
  { value: 'Myanmar', code: 'mm', isSupported: true, languages: ['Burmese'] },
  { value: 'Namibia', code: 'na', languages: ['English'] },
  { value: 'Nauru', code: 'nr', languages: ['English'] },
  { value: 'Nepal', code: 'np', languages: ['Nepali'] },
  { value: 'Netherlands', code: 'nl', languages: ['Dutch'] },
  { value: 'New Zealand', code: 'nz', languages: ['English', 'Māori'] },
  { value: 'Nicaragua', code: 'ni', languages: ['Spanish; Castilian'] },
  { value: 'Niger', code: 'ne', isSupported: true, languages: ['Hausa'] },
  { value: 'Nigeria', code: 'ng', languages: ['English'] },
  {
    value: 'North Korea',
    code: 'kp',
    isSupported: true,
    languages: ['Korean'],
  },
  {
    value: 'North Macedonia',
    code: 'mk',
    languages: ['Macedonian', 'Albanian'],
  },
  { value: 'Northern Cyprus', code: 'cy', languages: ['Turkish'] },
  { value: 'Norway', code: 'no', languages: ['Norwegian'] },
  { value: 'Oman', code: 'om', languages: ['Arabic'] },
  { value: 'Pakistan', code: 'pk', languages: ['Urdu', 'English'] },
  { value: 'Palau', code: 'pw', languages: ['English'] },
  { value: 'Palestine', code: 'ps', isSupported: true, languages: ['Arabic'] },
  { value: 'Panama', code: 'pa', languages: ['Spanish; Castilian'] },
  {
    value: 'Papua New Guinea',
    code: 'pg',
    languages: ['English', 'Hiri Motu'],
  },
  {
    value: 'Paraguay',
    code: 'py',
    languages: ['Spanish; Castilian', 'Guaraní'],
  },
  { value: 'Peru', code: 'pe', languages: ['Spanish; Castilian', 'Quechua'] },
  { value: 'Philippines', code: 'ph', languages: ['Filipino', 'English'] },
  { value: 'Poland', code: 'pl', languages: ['Polish'] },
  { value: 'Portugal', code: 'pt', languages: ['Portuguese'] },
  { value: 'Qatar', code: 'qa', languages: ['Arabic'] },
  {
    value: 'Republic of the Congo',
    code: 'cg',
    languages: ['French'],
  },
  { value: 'Romania', code: 'ro', languages: ['Romanian'] },
  { value: 'Russia', code: 'ru', isSupported: true, languages: ['Russian'] },
  {
    value: 'Rwanda',
    code: 'rw',
    languages: ['Kinyarwanda', 'English', 'French'],
  },
  { value: 'Saint Kitts and Nevis', code: 'kn', languages: ['English'] },
  { value: 'Saint Lucia', code: 'lc', languages: ['English'] },
  {
    value: 'Saint Vincent and the Grenadines',
    code: 'vc',
    languages: ['English'],
  },
  { value: 'Samoa', code: 'ws', languages: ['Samoan', 'English'] },
  { value: 'San Marino', code: 'sm', languages: ['Italian'] },
  { value: 'São Tomé and Príncipe', code: 'st', languages: ['Portuguese'] },
  { value: 'Saudi Arabia', code: 'sa', languages: ['Arabic'] },
  { value: 'Senegal', code: 'sn', languages: ['French'] },
  { value: 'Serbia', code: 'rs', languages: ['Serbian'] },
  { value: 'Seychelles', code: 'sc', languages: ['French', 'English'] },
  { value: 'Sierra Leone', code: 'sl', languages: ['English'] },
  {
    value: 'Singapore',
    code: 'sg',
    languages: ['English', 'Malay', 'Mandarin', 'Tamil'],
  },
  { value: 'Slovakia', code: 'sk', languages: ['Slovak'] },
  { value: 'Slovenia', code: 'si', languages: ['Slovenian'] },
  { value: 'Solomon Islands', code: 'sb', languages: ['English'] },
  {
    value: 'Somalia',
    code: 'so',
    isSupported: true,
    languages: ['Somali', 'Arabic'],
  },
  {
    value: 'South Africa',
    code: 'za',
    languages: ['Afrikaans', 'English', 'Zulu', 'Xhosa'],
  },
  { value: 'South Korea', code: 'kr', languages: ['Korean'] },
  {
    value: 'South Sudan',
    code: 'ss',
    isSupported: true,
    languages: ['English'],
  },
  {
    value: 'Spain',
    code: 'es',
    languages: ['Spanish; Castilian'],
  },
  {
    value: 'Sri Lanka',
    code: 'lk',
    languages: ['Sinhala', 'Tamil'],
  },
  {
    value: 'Sudan',
    code: 'sd',
    isSupported: true,
    languages: ['Arabic', 'English'],
  },
  { value: 'Suriname', code: 'sr', languages: ['Dutch'] },
  { value: 'Sweden', code: 'se', languages: ['Swedish'] },
  {
    value: 'Switzerland',
    code: 'ch',
    languages: ['German', 'French', 'Italian', 'Romansh'],
  },
  { value: 'Syria', code: 'sy', isSupported: true, languages: ['Arabic'] },
  { value: 'Taiwan', code: 'tw', languages: ['Mandarin'] },
  { value: 'Tajikistan', code: 'tj', languages: ['Tajik'] },
  { value: 'Tanzania', code: 'tz', languages: ['Swahili', 'English'] },
  { value: 'Thailand', code: 'th', languages: ['Thai'] },
  { value: 'Timor-Leste', code: 'tl', languages: ['Portuguese'] },
  { value: 'Togo', code: 'tg', languages: ['French'] },
  {
    value: 'Tonga',
    code: 'to',
    languages: ['Tonga (Tonga Islands)', 'English'],
  },
  { value: 'Trinidad and Tobago', code: 'tt', languages: ['English'] },
  { value: 'Tunisia', code: 'tn', languages: ['Arabic'] },
  { value: 'Türkiye', code: 'tr', languages: ['Turkish'] },
  { value: 'Turkmenistan', code: 'tm', languages: ['Turkmen'] },
  { value: 'Tuvalu', code: 'tv', languages: ['English'] },
  { value: 'Uganda', code: 'ug', languages: ['English', 'Swahili'] },
  {
    value: 'Ukraine',
    code: 'ua',
    isSupported: true,
    languages: ['Ukrainian'],
  },
  {
    value: 'United Arab Emirates',
    code: 'ae',
    languages: ['Arabic'],
  },
  { value: 'United Kingdom', code: 'gb', languages: ['English'] },
  {
    value: 'United States',
    code: 'us',
    languages: ['English'],
  },
  { value: 'Uruguay', code: 'uy', languages: ['Spanish; Castilian'] },
  { value: 'Uzbekistan', code: 'uz', languages: ['Uzbek'] },
  { value: 'Vanuatu', code: 'vu', languages: ['English', 'French'] },
  { value: 'Vatican City', code: 'va', languages: ['Italian'] },
  {
    value: 'Venezuela',
    code: 've',
    isSupported: true,
    languages: ['Spanish; Castilian'],
  },
  { value: 'Vietnam', code: 'vn', languages: ['Vietnamese'] },
  {
    value: 'Western Sahara',
    code: 'eh',
    languages: ['Arabic'],
  },
  { value: 'Yemen', code: 'ye', isSupported: true, languages: ['Arabic'] },
  { value: 'Zambia', code: 'zm', languages: ['English'] },
  { value: 'Zimbabwe', code: 'zw', languages: ['English', 'Shona'] },
] as const;

export type Countries = (typeof countries)[number]['value'];

export const supportedCountries = countries
  .filter(
    (c) =>
      Object.keys(c).includes('isSupported') &&
      (c as { isSupported: boolean }).isSupported
  )
  .map((c) => c.value) as string[];

export const languageToCountryMap = countries.reduce(
  (acc, c) => {
    c.languages.forEach((language) => {
      acc[language] = [...(acc[language] || []), c.value];
    });
    return acc;
  },
  {} as Record<string, string[]>
);
